<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/logo-lithos-dark.svg')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />

      <!-- <base-title
        size="body-1"
        space="4"
        title="MULTI-PURPOSE THEME"
        weight="regular"
      /> -->

      <base-body>
        리토스는 고객이 생각하는 제품을 위해 보다 만족하고 신뢰할 수 있는, 우수한 품질과 완성된 서비스를 제공해 드리려 정성을 아끼지 않습니다. 우리는 로고 디자인, 출판물, 웹 사이트 디자인과 개발, 모바일 어플리케이션 개발과 마케팅 계획, 비즈니스 모델 계획 등 고객이 원하는 맞춤형 서비스를 제시 할 수 있습니다. 리토스는 IT 비즈니스에 필요한 완벽한 서비스 파트너입니다.<br><br>
        리토스는 처음부터 한결같이 고객에게 최적의 디자인과 정확한 기획 그리고 최첨단 기술을 제공함으로써 고객 만족의 극대화를 위해 최선을 다합니다.우리는 진보하고 지속적인 서비스를 통해 고객이 생각하는 훌륭하고 참신한 제품을 보다 세련되고 멋스러운 서비스가 될 수 있도록 도와드립니다.리토스는 더 좋은 모바일 세상을 위해 노력하고 있습니다.
      </base-body>

      <base-btn
        class="mb-12"
        href="https://www.lithos.kr"
        color="white"
        target="_blank"
        outlined
      >
        More Info
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({

    }),
  }
</script>
